/* eslint-disable sort-keys */
import React from 'react';
import { MyBusiness, MyBusinessFilled, MyBusinessHover } from '@im/ui-lib/icons/nav/MyBusiness';
import { Products, ProductsHover, ProductsFilled } from '@im/ui-lib/icons/nav/Products';
import { Vendors, VendorsFilled, VendorsHover } from '@im/ui-lib/icons/nav/Vendors';
import { Help, HelpFilled, HelpHover } from '@im/ui-lib/icons/nav/Help';
import { Solutions, SolutionsFilled, SolutionsHover } from '@im/ui-lib/icons/nav/Solutions';
import { Services, ServicesFilled, ServicesHover } from '@im/ui-lib/icons/nav/Services';
import { Bundles, BundlesFilled, BundlesHover } from '@im/ui-lib/icons/nav/Bundles';
import { BusinessPlanning, BusinessPlanningFilled, BusinessPlanningHover } from '@im/ui-lib/icons/nav/BusinessPlanning';
import { Settings, SettingsFilled, SettingsHover } from '@im/ui-lib/icons/nav/Settings';
import { Events, EventsHover, EventsFilled } from '@im/ui-lib/icons/nav/Events';
import { Resources, ResourcesHover, ResourcesFilled } from '@im/ui-lib/icons/nav/Resources';
import { DataIngestion, DataIngestionFilled, DataIngestionHover } from '@im/ui-lib/icons/nav/DataIngestion';
import { Home } from '../../icons/Home';
import { HomeFilled } from '../../icons/HomeFilled';
import { jsx as _jsx } from "react/jsx-runtime";
var icons = {
  home: {
    active: HomeFilled,
    "default": Home,
    hover: HomeFilled
  },
  myBusiness: {
    active: MyBusinessFilled,
    "default": MyBusiness,
    hover: MyBusinessHover
  },
  products: {
    active: ProductsFilled,
    "default": Products,
    hover: ProductsHover
  },
  vendors: {
    active: VendorsFilled,
    "default": Vendors,
    hover: VendorsHover
  },
  help: {
    active: HelpFilled,
    "default": Help,
    hover: HelpHover
  },
  solutions: {
    active: SolutionsFilled,
    "default": Solutions,
    hover: SolutionsHover
  },
  services: {
    active: ServicesFilled,
    "default": Services,
    hover: ServicesHover
  },
  events: {
    active: EventsFilled,
    "default": Events,
    hover: EventsHover
  },
  resources: {
    active: ResourcesFilled,
    "default": Resources,
    hover: ResourcesHover
  },
  bundles: {
    active: BundlesFilled,
    "default": Bundles,
    hover: BundlesHover
  },
  business: {
    active: BusinessPlanningFilled,
    "default": BusinessPlanning,
    hover: BusinessPlanningHover
  },
  dataingestion: {
    active: DataIngestionFilled,
    "default": DataIngestion,
    hover: DataIngestionHover
  },
  settings: {
    active: SettingsFilled,
    "default": Settings,
    hover: SettingsHover
  }
};
export function renderSideNavItemIcon(key, active, hover) {
  var map = icons[key];
  if (!map) {
    return null;
  }
  var Icon = map["default"];
  if (active) {
    Icon = map.active;
  } else if (hover) {
    Icon = map.hover;
  }
  return /*#__PURE__*/_jsx(Icon, {
    "data-element": "Icon",
    "data-component": "renderSideNavItemIcon",
    "data-source-file": "renderSideNavItemIcon.tsx"
  });
}